<style lang="scss">
  @import "./index.scss";
</style>
<template>
    <div class="open-api">
        <h1>{{$t('openApi.title')}}</h1>

        <div class="con-wrap" style="margin-bottom:30px;">
            <div class="con-box">
                <!-- 申请数据接入按钮 -->
                <div v-show="!hasAccessKey" class="get-code-wrap">
                    <i-button @click="applyAccessKey" :disabled="btns.applyCode" class="get-code-button" type="primary">{{$t('openApi.applyCode')}}</i-button>
                    <p class="apply-tip" v-show="btns.applyTip">{{$t('openApi.applyTip')}}</p>
                </div>
                <!-- 申请后内容显示 -->
                <div v-show="hasAccessKey" class="has-code-wrap">
                    <!-- 数据接入码 -->
                    <div class="access-key">
                        <strong>{{$t('openApi.accessKey')}}</strong>
                        <span id="accessCode">{{accessKey}}</span>
                        <a class="copy-btn" data-clipboard-target="#accessCode" @click="clipKey">{{$t('openApi.copy')}}</a>
                    </div>
                    <!-- 已绑定的ip地址 -->
                    <div class="ip-list-wrap" v-show="hasIPList">
                        <div class="ip-item ip-box-wrap" v-for="(ip, key) in iPList" :key="key">
                            <div class="ip-o">
                                <i-input :disabled="ip.onlyReadIP" v-model="ip.a" class="ip-box"></i-input>
                                <strong>·</strong>
                                <i-input :disabled="ip.onlyReadIP" v-model="ip.b" class="ip-box"></i-input>
                                <strong>·</strong>
                                <i-input :disabled="ip.onlyReadIP" v-model="ip.c" class="ip-box"></i-input>
                                <strong>·</strong>
                                <i-input :disabled="ip.onlyReadIP" v-model="ip.d" class="ip-box"></i-input>

                                <i v-show="!ip.editStatus" @click="editIP(key)" class="edit-ip-btn fn-icon iconfont icon-edit"></i>
                                <Poptip v-if="!onlyOneIP" v-show="!ip.editStatus" class="delete-wrap" confirm :title="$t('openApi.deleteTip')" @on-ok="deleteIP(key)" >
                                    <i class="delete-ip-btn fn-icon iconfont icon-del"></i>
                                </Poptip>


                                <i-button v-if="ip.editStatus" @click="changeIP(key)" class="save-ip-button confirm-save" type="primary">{{$t('openApi.saveIP')}}</i-button>
                                <i-button v-if="ip.editStatus" @click="cancelEdit(key)" class="save-ip-button cancel-save">{{$t('openApi.cancel')}}</i-button>
                                <span v-if="ip.errorTip" class="ipTip" v-show="showIPTip">{{$t('openApi.invalidIP')}}</span>
                            </div>
                        </div>

                    </div>
                    <!-- 新增ip输入框 -->
                    <div v-if="bindIPBox" class="ip-box-wrap">
                        <div class="ip-o">
                            <i-input class="ip-box" v-model="ip.a" @on-blur="inspectIP"></i-input>
                            <strong>&middot;</strong>
                            <i-input class="ip-box" v-model="ip.b" @on-blur="inspectIP"></i-input>
                            <strong>&middot;</strong>
                            <i-input class="ip-box" v-model="ip.c" @on-blur="inspectIP"></i-input>
                            <strong>&middot;</strong>
                            <i-input class="ip-box" v-model="ip.d" @on-blur="inspectIP"></i-input>

                            <i-button class="save-ip-button confirm-save" @click="bindIP" type="primary">{{$t('openApi.saveIP')}}</i-button>
                            <i-button @click="cancelBind" class="save-ip-button cancel-save">{{$t('openApi.cancel')}}</i-button>
                            <span class="ipTip" v-show="showIPTip">{{$t('openApi.invalidIP')}}</span>
                        </div>
                    </div>
                    <!-- 新增ip按钮 -->
                    <i-button :disabled="btns.cannotAddIP" @click="showBindIPBox" class="add-ip-button" >{{$t('openApi.validIP')}}</i-button>
                </div>
            </div>
            <!-- 数据接口简介 -->
            <div  class="intro-box">
                <h2>
                    <Icon size="16" color="#657180" type="md-help-circle"></Icon>
                    <span>{{$t('openApi.intro.title')}}</span>
                </h2>
                <p v-for="(item, index) in $t('openApi.intro.desc')" :key="index">{{item}}</p>
                <p class="helpDoc">
                    <a href="http://doc.talkingdata.com/posts/42" target="_blank">
                    <Icon color="#3399FF" size="18" type="md-document"></Icon>
                    <span>{{$t('openApi.intro.helpDoc')}}</span>
                    <Icon color="#3399FF" size="18" type="ios-arrow-forward"></Icon></a>
                </p>
            </div>
        </div>
    </div>
</template>
<script>
import Clipboard from 'clipboard';
import util from '../../libs/util';
import bus from '../../libs/bus';

export default {
  data() {
    return {
      accessKey: '',
      bindIPBox: false,
      hasAccessKey: false, // 是否已申请AccessKey
      hasIPList: true,
      onlyOneIP: false,
      iPList: {},
      cancelEditParams: {
        flag: false,
        oldIp: [],
      },
      registertime: '',
      endTime: bus.selectedDate[1],
      btns: {
        applyCode: true,
        applyTip: false,
        cannotAddIP: false,  // 存在正在编辑的ip, 或ip数超过5个时为真
      },
      ip: {
        a: '',
        b: '',
        c: '',
        d: '',
      },
      showIPTip: false,
      pageid: '',
      httpFlag: {
        bindIp: false,
        changeIp: false,
        deleteIp: false,
      },
    };
  },
  mounted() {
    bus.$on('on-app-change', () => {
      this.init();
    });
    this.init();
  },
  beforeDestroy() {
    bus.$off('on-app-change');
  },
  methods: {
    init() {
      if (!bus.productInfo.productid) {
        return;
      }

      this.initData();
      this.queryAccessKey();
    },
    /* 切换应用时，初始化数据 */
    initData() {
      this.bindIPBox = false;
      this.hasAccessKey = false;
      this.hasIPList = true;
      this.onlyOneIP = false;
      this.iPList = {};
      this.registertime = bus.productInfo.registertime.split(' ')[0];
      this.endTime = bus.selectedDate[1];
      this.btns = {
        applyCode: true,
        cannotAddIP: false,
        applyTip: false,
      };
      this.ip = {
        a: '',
        b: '',
        c: '',
        d: '',
      };
      this.showIPTip = false;
      this.pageid = `openApi_${bus.token}`;
    },
    /* 获取access key */
    queryAccessKey() {
      const self = this;
      const params = {
        pageid: self.pageid,
        productid: bus.productInfo.productid,
      };
      util.ajax.get('/app/rest/openapi.json/queryAccesskey', { params })
        .then((res) => {
          if (res !== 'failed') {
            self.accessKey = res;
            self.hasAccessKey = true;
            self.getIPList();
          } else {
            self.getTotalUser();
          }
        });
    },
    /* 获取用户数（根据用户数判断是否可以申请access key） */
    getTotalUser() {
      const self = this;

      util.ajax.post('/app/rest/data.json/query', {
        metrics: ['totaluser'],
        groupby: 'productid',
        pageid: self.pageid,
        conditions: {
          developerid: bus.developerid,
          productid_list: [bus.productInfo.productid],
          platformid: bus.isAllPlatform ? '' : bus.platform.toString(),
          start: self.registertime,
          end: self.endTime,
        },
      })
        .then((res) => {
          if (res[0].totaluser >= 1000) {
            self.btns.applyCode = false;
          } else {
            self.btns.applyTip = true;
          }
        });
    },
    /* 获取绑定的ip列表 */
    getIPList() {
      const self = this;
      const params = {
        accesskey: self.accessKey,
        pageid: self.pageid,
      };

      util.ajax.get('/app/rest/openapi.json/queryAccessIpList', { params })
        .then((res) => {
          self.iPList = {};

          let ipArr = [];
          const keyArr = ['a', 'b', 'c', 'd'];
          let ipItem = {};
          let ip = '';
          let ipKey = '';

          if (res.length <= 1) {
            self.onlyOneIP = true;
          } else {
            self.onlyOneIP = false;
          }

          self.btns.cannotAddIP = res.length >= 5;

          for (let i = 0; i < res.length; i++) {
            ipItem = {};
            ip = res[i].ip;
            ipArr = ip.split('.');
            ipKey = `ip${ipArr.join('_')}`;

            if (!self.iPList[ipKey]) {
              for (let j = 0; j < ipArr.length; j++) {
                ipItem[keyArr[j]] = ipArr[j];
              }

              ipItem.editStatus = false;
              ipItem.onlyReadIP = true;
              ipItem.errorTip = false;
              self.$set(self.iPList, ipKey, ipItem);
            }
          }

          self.bindIPBox = false;
        });
    },
    /* 申请access key */
    applyAccessKey() {
      if (bus.demoTip()) return;

      const self = this;
      const params = {
        pageid: self.pageid,
        productid: bus.productInfo.productid,
      };
      util.ajax.get('/app/rest/openapi.json/buildAccesskey', { params })
        .then((res) => {
          self.accessKey = res;
          self.hasAccessKey = true;
        });
    },
    /* 复制 */
    clipKey() {
      const self = this;
      const clip = new Clipboard('.copy-btn');

      clip.on('success', () => {
        self.$Message.destroy();
        self.$Message.success({
          content: self.$t('openApi.tip.copySuccess'),
          duration: 3,
        });
      }).on('error', () => {
        self.$Message.destroy();
        self.$Message.warning({
          content: self.$t('openApi.tip.copyError'),
          duration: 3,
        });
      });
    },
    /* 显示添加ip的DOM */
    showBindIPBox() {
      this.ip = {
        a: '',
        b: '',
        c: '',
        d: '',
      };

      this.showIPTip = false;
      this.btns.cannotAddIP = true;
      this.bindIPBox = true;
    },
    /* 检查ip合法性 */
    inspectIP(curIp, type) {
      const self = this;
      const ip = curIp || self.ip;
      const reg = new RegExp('^[0-9]*$');

      if (type === 'allRequired' && !(ip.a && ip.b && ip.c && ip.d)) {
        self.showIPTip = true;
        return false;
      }

      if ((ip.a && !reg.test(ip.a)) ||
        (ip.b && !reg.test(ip.b)) ||
        (ip.c && !reg.test(ip.c)) ||
        (ip.d && !reg.test(ip.d))) {
        self.showIPTip = true;
        return false;
      }
      if (ip.a && (Number(ip.a) < 0 || Number(ip.a) > 255)) {
        self.showIPTip = true;
        return false;
      }
      if (ip.b && (Number(ip.b) < 0 || Number(ip.b) > 255)) {
        self.showIPTip = true;
        return false;
      }
      if (ip.c && (Number(ip.c) < 0 || Number(ip.c) > 255)) {
        self.showIPTip = true;
        return false;
      }
      if (ip.d && (Number(ip.d) < 0 || Number(ip.d) > 255)) {
        self.showIPTip = true;
        return false;
      }
      self.showIPTip = false;
      return true;
    },
    /* 新增ip事件 */
    bindIP() {
      /* demo环境下，禁止操作 */
      if (bus.demoTip()) return;

      /* 检查要提交的ip是否合法 */
      if (!this.inspectIP(this.ip, 'allRequired')) return;

      /* 避免重复提交 */
      if (this.httpFlag.bindIp) return;

      const self = this;
      const ip = [self.ip.a, self.ip.b, self.ip.c, self.ip.d].join('.');
      const params = {
        accesskey: self.accessKey,
        iplist: ip,
        pageid: self.pageid,
      };

      this.httpFlag.bindIp = true;
      util.ajax.get('/app/rest/openapi.json/authAccessIp', { params })
        .then((res) => {
          this.httpFlag.bindIp = false;

          if (res === 'succ') {
            self.getIPList();
          } else {
            self.$Message.warning({
              content: self.$t('openApi.tip.copyError'),
              duration: 3,
            });
          }
        });
    },
    /* 取消新增事件 */
    cancelBind() {
      this.bindIPBox = false;
      this.btns.cannotAddIP = false;
    },
    /* 编辑ip事件 */
    editIP(index) {
      /* 判断正在新增ip item显示时，不可操作 */
      if (this.bindIPBox) return;

      Object.keys(this.iPList).forEach((i) => {
        this.iPList[i].onlyReadIP = true;
        this.iPList[i].editStatus = false;
      });

      this.iPList[index].onlyReadIP = false;
      this.iPList[index].editStatus = true;

      this.cancelEdit.flag = false;
      this.cancelEdit.oldIp = [];

      this.btns.cannotAddIP = true;
    },
    /* 修改已有ip */
    changeIP(index) {
      /* demo环境下，禁止操作 */
      if (bus.demoTip()) return;

      const self = this;
      const newipObj = self.iPList[index];

      /* 若当前ip不合法，禁止操作 */
      if (!this.inspectIP(newipObj, 'allRequired')) {
        self.iPList[index].errorTip = true;
        self.cancelEditParams.flag = true;
        self.cancelEditParams.oldIp = index.substring(2).split('_');
        return;
      }

      /* 避免重复提交 */
      if (this.httpFlag.changeIp) return;

      const oOldip = index.substring(2).split('_').join('.');
      const oNewip = `${newipObj.a}.${newipObj.b}.${newipObj.c}.${newipObj.d}`;
      const params = {
        accesskey: self.accessKey,
        newip: oNewip,
        oldip: oOldip,
        pageid: self.pageid,
      };

      this.httpFlag.changeIp = true;
      util.ajax.get('/app/rest/openapi.json/updateAccessIp', { params })
        .then(() => {
          this.httpFlag.changeIp = false;
          self.getIPList();
        });
    },
    /* 取消编辑ip事件 */
    cancelEdit(index) {
      const oldIp = this.cancelEditParams.flag ?
        this.cancelEditParams.oldIp :
        index.substring(2).split('_');

      this.iPList[index].a = oldIp[0];
      this.iPList[index].b = oldIp[1];
      this.iPList[index].c = oldIp[2];
      this.iPList[index].d = oldIp[3];

      this.iPList[index].errorTip = false;
      this.iPList[index].onlyReadIP = true;
      this.iPList[index].editStatus = false;
      this.btns.cannotAddIP = false;
    },
    /* 删除ip */
    deleteIP(index) {
      /* demo环境 禁止操作 */
      if (bus.demoTip()) return;

      /* 判断正在新增ip item显示时，不可操作 */
      if (this.bindIPBox) return;

      /* 避免重复提交 */
      if (this.httpFlag.changeIp) return;

      const self = this;
      const ipObj = self.iPList[index];
      const oIp = `${ipObj.a}.${ipObj.b}.${ipObj.c}.${ipObj.d}`;
      const params = {
        accesskey: self.accessKey,
        ip: oIp,
        pageid: self.pageid,
      };

      this.httpFlag.changeIp = true;
      util.ajax.get('/app/rest/openapi.json/deleteAccessIp', { params })
      .then(() => {
        this.httpFlag.changeIp = false;

        self.getIPList();
      });
    },
  },
};
</script>
